import React, { useState } from 'react';

const RoadmapWhatWhyHow = () => {
  const [selectedMonth, setSelectedMonth] = useState(null);

  const roadmapData = [
    {
      month: "Agustus 2025",
      monthNumber: "08",
      color: "from-blue-500 to-blue-600",
      bgColor: "bg-blue-50",
      what: [
        "Kick-off Tim Digitalisasi",
        "Finalisasi Pembuatan Roadmap Digitalisasi Al Wafi",
        "Distribusi iPad ke guru & pengasuh",
        "Setup dasar MDM",
        "Pelatihan penggunaan awal iPad"
      ],
      why: "Memberikan kejelasan serta meningkatkan minat wali santri & santri untuk menggunakan IPAD. Memberi akses awal & pembiasaan perangkat digital",
      how: [
        "Penugasan detail dalam Tim Transformasi Digital",
        "Melaksanakan FGD dengan wali santri sambil mempresentasikan roadmap, fitur dan manfaat IPAD",
        "Distribusi perangkat sesuai data penerima",
        "Setup dasar MDM oleh vendor",
        "Workshop penggunaan iPad & etika digital"
      ],
      pic: [
        "Tim Transformasi Digital",
        "Manajemen Sekolah",
        "Tim IT",
        "Vendor MDM",
        "Tim Pelatihan"
      ]
    },
    {
      month: "September 2025",
      monthNumber: "09",
      color: "from-green-500 to-green-600",
      bgColor: "bg-green-50",
      what: [
        "Audit infrastruktur IT",
        "Menentukan tempat penyimpanan IPAD santri"
      ],
      why: "Memastikan kesiapan teknis maupun tempat",
      how: [
        "Cek jaringan & server",
        "Memastikan perangkat WIFI memadai secara menyeluruh untuk santri maupun guru",
        "Cek penyimpanan yang bagus di pengasuhan & pendidikan"
      ],
      pic: [
        "Tim IT",
        "Tim Infrastruktur",
        "Tim Pengasuhan",
        "Tim Pendidikan",
        "Manajemen Fasilitas"
      ]
    },
    {
      month: "Oktober 2025",
      monthNumber: "10",
      color: "from-purple-500 to-purple-600",
      bgColor: "bg-purple-50",
      what: [
        "Setup lanjutan MDM & LMS",
        "Perancangan struktur akun, kelas, Kamar dan fitur LMS"
      ],
      why: "Membentuk pondasi teknis digital sesuai kebutuhan sekolah",
      how: [
        "Vendor setup MDM per pengguna (guru/siswa)",
        "Tim kurikulum desain LMS (kelas, menu, akses guru/siswa)"
      ],
      pic: [
        "Vendor MDM",
        "Tim IT",
        "Tim Kurikulum",
        "Tim Pengasuhan",
        "Tim QA"
      ]
    },
    {
      month: "November 2025",
      monthNumber: "11",
      color: "from-orange-500 to-orange-600",
      bgColor: "bg-orange-50",
      what: [
        "Penyusunan SOP iPad & LMS",
        "Standarisasi konten digital awal"
      ],
      why: "Menjamin kedisiplinan dan kualitas konten digital",
      how: [
        "Draft & validasi SOP oleh Tim",
        "Buat format/template: modul, e-book, video, kuis"
      ],
      pic: [
        "Tim QA",
        "Tim Pendidikan",
        "Tim Pengasuhan",
        "Tim Kurikulum",
        "Manajemen Sekolah"
      ]
    },
    {
      month: "Desember 2025",
      monthNumber: "12",
      color: "from-red-500 to-red-600",
      bgColor: "bg-red-50",
      what: [
        "Pengadaan iPad siswa tahap 1 (kelas pilot)",
        "Pelatihan guru lanjutan",
        "Setup akun LMS"
      ],
      why: "Mempersiapkan penggunaan terbatas oleh siswa & konten siap pakai",
      how: [
        "Distribusi iPad batch 1",
        "Pelatihan membuat konten digital",
        "Buat akun LMS guru-siswa kelas pilot"
      ],
      pic: [
        "Tim Pengadaan",
        "Tim Pelatihan",
        "Tim IT",
        "Tim QA",
        "Guru Kelas Pilot"
      ]
    },
    {
      month: "Januari 2026",
      monthNumber: "01",
      color: "from-indigo-500 to-indigo-600",
      bgColor: "bg-indigo-50",
      what: [
        "Produksi konten semester genap",
        "Integrasi sistem",
        "Pembelajaran penilaian, absensi, presensi asrama"
      ],
      why: "Memastikan proses belajar & pengasuhan mulai digitalisasi bertahap",
      how: [
        "Guru buat konten yaitu memasukkan pembelajaran di LMS",
        "Sinkronisasi data nilai, absensi, pelanggaran dengan sistem"
      ],
      pic: [
        "Tim Guru",
        "Tim IT",
        "Tim Pengasuhan",
        "Tim QA",
        "Tim Kurikulum"
      ]
    },
    {
      month: "Februari 2026",
      monthNumber: "02",
      color: "from-pink-500 to-pink-600",
      bgColor: "bg-pink-50",
      what: [
        "Pelatihan siswa",
        "Simulasi sistem oleh kelas pilot",
        "Sosialisasi lanjutan ke wali santri"
      ],
      why: "Uji awal penggunaan real oleh siswa dan edukasi orang tua terhadap sistem baru",
      how: [
        "Sesi pengenalan iPad untuk siswa",
        "Uji coba pembelajaran digital",
        "Distribusi booklet & seminar untuk orang tua"
      ],
      pic: [
        "Tim Pelatihan",
        "Guru Kelas Pilot",
        "Tim Pengasuhan",
        "Tim Media",
        "Tim QA"
      ]
    },
    {
      month: "Maret 2026",
      monthNumber: "03",
      color: "from-teal-500 to-teal-600",
      bgColor: "bg-teal-50",
      what: [
        "Evaluasi pilot project",
        "Optimalisasi fitur sistem & metodologi digital"
      ],
      why: "Mengoreksi kekurangan sebelum ekspansi penuh",
      how: [
        "Survei guru/siswa/ortu",
        "FGD evaluasi dan perbaikan konten & sistem"
      ],
      pic: [
        "Tim QA",
        "Tim Evaluasi",
        "Manajemen Sekolah",
        "Tim IT",
        "Tim Pengasuhan"
      ]
    },
    {
      month: "April 2026",
      monthNumber: "04",
      color: "from-yellow-500 to-yellow-600",
      bgColor: "bg-yellow-50",
      what: [
        "Distribusi iPad siswa batch akhir",
        "Setup sistem penuh di semua unit"
      ],
      why: "Implementasi menyeluruh ke seluruh kelas & asrama",
      how: [
        "Distribusi final perangkat",
        "Setup LMS-MDM di semua kelas dan kamar asrama"
      ],
      pic: [
        "Tim Pengadaan",
        "Tim IT",
        "Tim Pengasuhan",
        "Tim Pendidikan",
        "Tim QA"
      ]
    },
    {
      month: "Mei 2026",
      monthNumber: "05",
      color: "from-emerald-500 to-emerald-600",
      bgColor: "bg-emerald-50",
      what: [
        "Simulasi penuh 1 minggu",
        "Finalisasi konten digital semester ganjil 2026/2027"
      ],
      why: "Uji coba akhir dan perapihan konten",
      how: [
        "Aktivitas belajar dan boarding digital penuh selama 1 pekan",
        "Koreksi konten oleh guru"
      ],
      pic: [
        "Seluruh Tim Guru",
        "Tim Pengasuhan",
        "Tim IT",
        "Tim QA",
        "Manajemen Sekolah"
      ]
    },
    {
      month: "Juni 2026",
      monthNumber: "06",
      color: "from-cyan-500 to-cyan-600",
      bgColor: "bg-cyan-50",
      what: [
        "Refreshment training guru & pengasuh",
        "Audit keamanan data & sistem"
      ],
      why: "Memastikan kesiapan total semua SDM & kestabilan sistem menjelang peluncuran resmi",
      how: [
        "Training lanjutan & troubleshooting",
        "Vendor & Tim IT audit sistem: akses, keamanan data, manajemen akun"
      ],
      pic: [
        "Tim Pelatihan",
        "Tim IT",
        "Vendor Sistem",
        "Tim Keamanan",
        "Tim QA"
      ]
    },
    {
      month: "Juli 2026",
      monthNumber: "07",
      color: "from-violet-500 to-violet-600",
      bgColor: "bg-violet-50",
      what: [
        "Finalisasi SOP & panduan",
        "Launching sistem digital sekolah tahun ajaran 2026/2027"
      ],
      why: "Menandai transisi resmi ke ekosistem digital",
      how: [
        "Cetak buku panduan penggunaan iPad, LMS, SOP",
        "Acara launching internal untuk guru & santri dan eksternal untuk publik & ortu"
      ],
      pic: [
        "Manajemen Sekolah",
        "Tim Media",
        "Tim QA",
        "Tim IT",
        "Seluruh Tim"
      ]
    }
  ];

  const finalOutputs = [
    {
      number: "1",
      title: "Seluruh guru, pengasuh, dan siswa aktif menggunakan iPad dalam proses belajar & asrama",
      icon: "fas fa-users",
      color: "text-blue-600",
      bgColor: "bg-blue-50"
    },
    {
      number: "2", 
      title: "MDM mengelola semua perangkat secara terpusat, terkontrol, dan aman",
      icon: "fas fa-shield-alt",
      color: "text-green-600",
      bgColor: "bg-green-50"
    },
    {
      number: "3",
      title: "LMS menjadi platform utama pembelajaran, komunikasi orang tua, dan pelaporan santri",
      icon: "fas fa-graduation-cap",
      color: "text-purple-600",
      bgColor: "bg-purple-50"
    },
    {
      number: "4",
      title: "Seluruh proses belajar & pengasuhan terintegrasi digital",
      icon: "fas fa-link",
      color: "text-orange-600",
      bgColor: "bg-orange-50"
    }
  ];

  return (
    <div className="min-h-screen py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-purple-500 to-pink-600 rounded-full mb-6">
            <i className="fas fa-question-circle text-white text-3xl"></i>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Roadmap What - Why - How - PIC
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Penjelasan lengkap APA yang dilakukan, MENGAPA penting, BAGAIMANA cara melaksanakannya, dan SIAPA yang bertanggung jawab dalam setiap bulan transformasi digital Al Wafi
          </p>
        </div>

        {/* Methodology Explanation */}
        <section className="mb-16">
          <div className="bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl p-8 text-white">
            <h2 className="text-3xl font-bold text-center mb-8">Metodologi What-Why-How-PIC</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-list text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold mb-2">WHAT</h3>
                <p className="text-purple-100">Aktivitas dan kegiatan yang akan dilaksanakan pada bulan tersebut</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-lightbulb text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold mb-2">WHY</h3>
                <p className="text-purple-100">Alasan dan tujuan mengapa aktivitas tersebut penting dilakukan</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-cogs text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold mb-2">HOW</h3>
                <p className="text-purple-100">Cara konkret dan langkah-langkah untuk melaksanakan aktivitas</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-users text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold mb-2">PIC</h3>
                <p className="text-purple-100">Tim dan pihak yang bertanggung jawab melaksanakan aktivitas</p>
              </div>
            </div>
          </div>
        </section>

        {/* Monthly Roadmap */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Roadmap Bulanan</h2>
          <div className="space-y-6">
            {roadmapData.map((monthData, index) => (
              <div key={index} className={`${monthData.bgColor} rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden`}>
                <div className={`h-2 bg-gradient-to-r ${monthData.color}`}></div>
                <div className="p-6">
                  <div 
                    className="flex items-center justify-between cursor-pointer"
                    onClick={() => setSelectedMonth(selectedMonth === index ? null : index)}
                  >
                    <div className="flex items-center space-x-4">
                      <div className={`w-16 h-16 bg-gradient-to-r ${monthData.color} rounded-full flex items-center justify-center`}>
                        <span className="text-white font-bold text-lg">{monthData.monthNumber}</span>
                      </div>
                      <div>
                        <h3 className="text-2xl font-bold text-gray-800">{monthData.month}</h3>
                        <p className="text-gray-600">{monthData.what.length} aktivitas utama</p>
                      </div>
                    </div>
                    <i className={`fas ${selectedMonth === index ? 'fa-chevron-up' : 'fa-chevron-down'} text-gray-400 text-xl`}></i>
                  </div>

                  {selectedMonth === index && (
                    <div className="mt-6 grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-6">
                      {/* WHAT */}
                      <div className="bg-white rounded-lg p-6 shadow-sm">
                        <h4 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
                          <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center mr-3">
                            <i className="fas fa-list text-white text-sm"></i>
                          </div>
                          WHAT - Apa yang Dilakukan
                        </h4>
                        <div className="space-y-3">
                          {monthData.what.map((item, itemIndex) => (
                            <div key={itemIndex} className="flex items-start space-x-3">
                              <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                                <span className="text-blue-600 font-bold text-sm">{itemIndex + 1}</span>
                              </div>
                              <span className="text-gray-700 text-sm">{item}</span>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* WHY */}
                      <div className="bg-white rounded-lg p-6 shadow-sm">
                        <h4 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
                          <div className="w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center mr-3">
                            <i className="fas fa-lightbulb text-white text-sm"></i>
                          </div>
                          WHY - Mengapa Penting
                        </h4>
                        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                          <p className="text-gray-700 leading-relaxed">{monthData.why}</p>
                        </div>
                      </div>

                      {/* HOW */}
                      <div className="bg-white rounded-lg p-6 shadow-sm">
                        <h4 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
                          <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center mr-3">
                            <i className="fas fa-cogs text-white text-sm"></i>
                          </div>
                          HOW - Bagaimana Caranya
                        </h4>
                        <div className="space-y-3">
                          {monthData.how.map((step, stepIndex) => (
                            <div key={stepIndex} className="flex items-start space-x-3">
                              <i className="fas fa-arrow-right text-green-500 mt-1 flex-shrink-0"></i>
                              <span className="text-gray-700 text-sm">{step}</span>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* PIC */}
                      <div className="bg-white rounded-lg p-6 shadow-sm">
                        <h4 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
                          <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center mr-3">
                            <i className="fas fa-users text-white text-sm"></i>
                          </div>
                          PIC - Yang Terlibat
                        </h4>
                        <div className="space-y-3">
                          {monthData.pic.map((person, personIndex) => (
                            <div key={personIndex} className="flex items-start space-x-3">
                              <i className="fas fa-user-circle text-purple-500 mt-1 flex-shrink-0"></i>
                              <span className="text-gray-700 text-sm">{person}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Final Outputs */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Output Akhir Juli 2026</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {finalOutputs.map((output, index) => (
              <div key={index} className={`${output.bgColor} rounded-xl p-6 border-l-4 border-current ${output.color} hover:shadow-lg transition-all duration-300`}>
                <div className="flex items-start space-x-4">
                  <div className={`w-12 h-12 ${output.bgColor} rounded-lg flex items-center justify-center border-2 border-current ${output.color} flex-shrink-0`}>
                    <span className={`${output.color} font-bold text-lg`}>{output.number}</span>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-start space-x-3">
                      <i className={`${output.icon} ${output.color} text-lg mt-1`}></i>
                      <p className="text-gray-700 leading-relaxed">{output.title}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Timeline Summary */}
        <section className="mb-16">
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Ringkasan Timeline</h2>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              <div className="text-center p-6 bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl">
                <div className="text-3xl font-bold text-blue-600 mb-2">12</div>
                <div className="text-blue-700 font-semibold">Bulan</div>
                <div className="text-blue-600 text-sm">Agustus 2025 - Juli 2026</div>
              </div>
              <div className="text-center p-6 bg-gradient-to-br from-green-50 to-green-100 rounded-xl">
                <div className="text-3xl font-bold text-green-600 mb-2">{roadmapData.reduce((total, month) => total + month.what.length, 0)}</div>
                <div className="text-green-700 font-semibold">Aktivitas</div>
                <div className="text-green-600 text-sm">Total Kegiatan</div>
              </div>
              <div className="text-center p-6 bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl">
                <div className="text-3xl font-bold text-purple-600 mb-2">4</div>
                <div className="text-purple-700 font-semibold">Output Utama</div>
                <div className="text-purple-600 text-sm">Hasil Akhir</div>
              </div>
              <div className="text-center p-6 bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl">
                <div className="text-3xl font-bold text-orange-600 mb-2">100%</div>
                <div className="text-orange-700 font-semibold">Digital</div>
                <div className="text-orange-600 text-sm">Transformasi</div>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="text-center">
          <div className="bg-gradient-to-r from-purple-500 to-pink-600 rounded-2xl p-8 text-white">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white bg-opacity-20 rounded-full mb-6">
              <i className="fas fa-question-circle text-white text-2xl"></i>
            </div>
            <h2 className="text-3xl font-bold mb-4">Sudah Paham What-Why-How-PIC?</h2>
            <p className="text-xl mb-8 opacity-90 max-w-3xl mx-auto">
              Dengan memahami apa, mengapa, bagaimana, dan siapa yang bertanggung jawab, implementasi digitalisasi akan lebih terarah dan sukses
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-white text-purple-600 px-8 py-4 rounded-full font-semibold text-lg hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1">
                <i className="fas fa-download mr-2"></i>
                Download Panduan
              </button>
              <button className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white hover:text-purple-600 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1">
                <i className="fas fa-phone mr-2"></i>
                Diskusi Lebih Lanjut
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default RoadmapWhatWhyHow;
